module.exports = __webpack_public_path__ + "img/ic_country_serve_img1.1ca51896.png";